<template>
  <NuxtLayout name="magazine">
    <div class="page-container py-6">
      <MoleculesGlobalBreadcrumb />
      <AtomsTextHeader :type="1">{{ $t('Svatební magazín') }}</AtomsTextHeader>
      <div class="flex flex-wrap items-center gap-4 my-6">
        <span class="w-full lg:w-auto">
          {{ $t('Kategorie') }}:
        </span>
        <label v-for="item in categories" :key="item.id" class="inline-flex mr-6 cursor-pointer">
          <AtomsFormsCheckbox class="mr-2" @change="(...args) => selectCategory(item.id, ...args)" /> <strong class="text-gray text-sm">{{ extractCategoryName(item.name) }}</strong>
        </label>
      </div>
      <div class="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6">
        <MoleculesBlocksMagazineItem v-for="item in items" :key="item.id" :title="item.page.title" :url="item.page.url" :image-url="`https://www.sperky4u.eu/img/magazine/${item.id}_cover.jpg`" :date="item.page.lastModifiedAt ? (item.created > item.page.lastModifiedAt ? item.created : item.page.lastModifiedAt) : item.created" :minutes-to-read="item.timeToRead" />
      </div>
      <OrganismsListsPaging :label="i18n.t('článků')" :label-more="i18n.t('Další články')" class="mt-6" :shown-items="shownItems" :total-pages="totalPages" :current-page="page" :total-items="totalItems" />
    </div>
  </NuxtLayout>
</template>
<script setup>

const i18n = useI18n();
const locale = useLocale().getLocale();
const entity = useEntity();
const appConfig = useAppConfig();

const pageSize = appConfig.magazineList.itemsOnPage;

const items = ref(entity.infoPages.infoPages.items);
const page = ref(1);
const totalItems = ref(entity.infoPages.infoPages.count);
const categories = entity.categories.filter(item => appConfig.magazineCategoryIds.includes(item.id));

const shownItems = computed(() => Math.min(page.value * pageSize, totalItems.value));
const totalPages = computed(() => pageSize > 0 ? Math.ceil(totalItems.value / pageSize) : 0);

const selectedCategories = ref([]);

const extractCategoryName = (nameWithPrefix) => nameWithPrefix.slice(nameWithPrefix.indexOf('-') + 1);

const selectCategory = (id, active) => {
  page.value = 1;
  useRouter().push('');

  if (active) {
    selectedCategories.value.push(id);
  }
  else {
    const index = selectedCategories.value.indexOf(id);

    selectedCategories.value.splice(index, 1);
  }

  loadItems();
}

const loadItems = async (append = false) => {

  const selectedCategoryIds = (selectedCategories.value.length === 0 ? categories.map(item => item.id) : selectedCategories.value).join(',');

  const modifiedHashObj = useShopRouting().updateValueInHash('p', page.value, false, true);

  const queryUrl = `/api/magazineArticles?categoryIds=${selectedCategoryIds}&currencyId=${locale.currencyId}&languageId=${locale.languageId}&${useShopRouting().stringifyHash(modifiedHashObj).replace('#!', '')}`;
  const result = (await useApiFetch(queryUrl)).data.value.infoPageList.infoPages;

  if (append) {
    items.value = items.value.concat(result.items);
  }
  else {
    items.value = result.items;
  }

  totalItems.value = result.count;
}

// reload items when the page hash changes
watch(() => useRoute().hash, async () => {

  const hash = useShopRouting().parseHash();

  const pageParameter = hash.find(q => q.key === 'p')?.value.toString() ?? "1";
  const pageNumber = parseInt(pageParameter.split('-')[0]);
  const append = pageParameter.split('-').length === 2 && pageParameter.split('-')[1] === 'a';

  page.value = pageNumber;

  if (hash.length) {
    loadItems(append);
  }
});

</script>